import {ChangeDetectionStrategy, Component, Input} from "@angular/core";
import {Product, StandardName} from "../../../../../store/state/order.state";
import {ChangeSet} from "../../../history/order-history.model";
import {TranslationsHelperService} from "../../../../translations/translations-helper.service";

@Component({
    selector: 'company-details',
    templateUrl: './company-details.template.html',
    styleUrls: ['./company-details.style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CompanyDetailsComponent  {

	@Input() product: Product;
	@Input() translateClientsData: boolean;
	@Input() changeSet: ChangeSet;	// optional
	@Input() useOriginalTranslations: boolean;

	constructor(public translationsHelper: TranslationsHelperService) {
	}

	get numberOfEmployees(): number {
		return this.product.employees;
	}

	standardNameWithTimestamp(): string {
		// added milliseconds to distinguish radio buttons in different components: UMB-5539
		return this.product.standard.name.toLowerCase() + new Date().getMilliseconds();
	}

	standardName(): StandardName {
		return this.product.standard.name;
	}

	areEmployeesChanged(): boolean {
		return !!this.changeSet && !!this.changeSet.changes.productChanges[this.product.standard.name] &&
			!!this.changeSet.changes.productChanges[this.product.standard.name].employees;
	}

	isCompanyDescriptionChanged(): boolean {
		return !!this.changeSet && !!this.changeSet.changes.productChanges[this.product.standard.name] &&
			!!this.changeSet.changes.productChanges[this.product.standard.name].companyDescription;
	}

	isScopeDescriptionChanged() {
		return !!this.changeSet && !!this.changeSet.changes.productChanges[this.product.standard.name] &&
			(!!this.changeSet.changes.productChanges[this.product.standard.name].scopeDescriptionNeedsNarrowing || !!this.changeSet.changes.productChanges[this.product.standard.name].scopeDescription);
	}

	translationExists(subject: string): boolean {
		return this.translationsHelper.translationExists(this.standardName(), subject, this.useOriginalTranslations);
	}

	getTranslation(subject: string): string {
		return this.translationsHelper.getTranslation(this.standardName(), subject, this.useOriginalTranslations);
	}
}
